import React from 'react'
import {useContext} from 'react';
import {PortfolioContext} from '../../contexts/recentsWorks';
import ProjectCard from './ProjectCard';
import Loading from './../Loading';
// import Tilt from 'react-parallax-tilt';
import Grid from '@material-ui/core/Grid';

export default function FeaturedProjects() {
    const context = useContext(PortfolioContext);
    const {loading} = context;
    let featured = context.featuredProjects;

    return (
        <div className='featuredProjects'>
            <h4>Featured Works</h4>
            {loading
                ? <Loading/>
                : <Grid container className='text-center'>
                    {featured.map((item, index) => {
                        return <Grid key={index} item xs={6} sm={6} md={4}>
                                <ProjectCard
                                  key={index}
                                  name={item.name}
                                  description={item.description}
                                  featured={item.featured}
                                  forSale={item.forSale}
                                  images={item.images}
                                  saleCover={item.saleCover}
                                  slug={item.slug}
                                />
                        </Grid>
                    })
}
                </Grid>
}

        </div>
    )
}
